// src/data/headlineData.ts

export interface HeadlineFlowItemData {
    id: string; // Unique identifier, e.g., "wsj-headline-1"
    imageSrc: string; // Path to the composite image, e.g., "/images/headlines/wsj.png"
    publication: string; // For alt text, e.g., "The Wall Street Journal"
    headline: string; // For alt text, e.g., "Why Do All These 20-Somethings Have Closed Captions Turned On?"
  }
  
  export const headlineFlowData: HeadlineFlowItemData[] = [
    {
      id: "wsj-headline",
      imageSrc: "/images/headlines/wsj.png",
      publication: "The Wall Street Journal",
      headline: "Why Do All These 20-Somethings Have Closed Captions Turned On?",
    },
    {
      id: "nyt-headline",
      imageSrc: "/images/headlines/nyt.png",
      publication: "The New York Times",
      headline: "Do You Know How Much a Home Costs?",
    },
    {
      id: "npr-headline",
      imageSrc: "/images/headlines/npr.png",
      publication: "NPR",
      headline: "How to handle all the workplace jargon",
    },
    {
      id: "atlantic-headline",
      imageSrc: "/images/headlines/atlantic.png",
      publication: "The Atlantic",
      headline: "Group-Chat Culture Is Out of Control",
    },
    {
      id: "bbc-headline",
      imageSrc: "/images/headlines/bbc.png",
      publication: "BBC",
      headline: "Passive-aggressive colleagues who poison workplaces",
    },
    {
      id: "fast-company-headline",
      imageSrc: "/images/headlines/fastcompany.png",
      publication: "Fast Company",
      headline: "Have you been 'quietly promoted'?",
    },
    {
      id: "latimes-headline",
      imageSrc: "/images/headlines/latimes.png",
      publication: "The Los Angeles Times",
      headline: "What your kids wish you knew about Instagram",
    },
    {
      id: "inc-headline",
      imageSrc: "/images/headlines/inc.png",
      publication: "Inc",
      headline: "Young Americans Have No Interest in the Most In-Demand Jobs",
    },
    {
      id: "cbs-headline",
      imageSrc: "/images/headlines/cbs.png",
      publication: "CBS News",
      headline: "Nearly 40% of adults have lied to partner about finances, survey finds",
    },
    {
      id: "axios-headline",
      imageSrc: "/images/headlines/axios.png",
      publication: "Axios",
      headline: "How to speak proper emoji",
    },
    {
      id: "travelleisure-headline",
      imageSrc: "/images/headlines/travelleisure.png",
      publication: "Travel and Leisure",
      headline: "These cities have the highest Airbnb fees",
    },
    {
      id: "politico-headline",
      imageSrc: "/images/headlines/politico.png", 
      publication: "Politico",
      headline: "Angry Birds: Analysis of the 85 most-followed American political figures",
    },
  ];
  